module.exports = __webpack_public_path__ + "static/media/pikachu.81f6252e.gif";